import React, { FC } from 'react';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import { RoundIcon, RoundIconVariants } from '@components/atoms/RoundIcon';
import { Container } from '@components/atoms/Container';
import { Typography, TypographyAppearanceVariants, TypographyTagVariants } from '@components/atoms/Typography';
import styles from './ServiceAboutText.module.css';
import { useThemes } from '@hooks/useThemes';

export interface ServiceAboutTextProps {
    content: string;
    onEditClick?: () => void;
}

export const ServiceAboutText: FC<ServiceAboutTextProps> = ({ content, onEditClick }) => {
    const { t } = useTranslation();
    const { useGrayscaleTheme } = useThemes();

    const translations = {
        title: t('service-about-text-component.title'),
    };

    return (
        <Container classes="px-0" customSize="custom-large">
            <div className="position-relative" data-testid="service-about-text">
                <Typography
                    classes="mb-3"
                    tagVariant={TypographyTagVariants.h2}
                    appearanceLevel={TypographyAppearanceVariants.level3}>
                    {translations.title}
                </Typography>

                {onEditClick && (
                    <div className="p-0 mt-2 position-absolute end-0 top-0 text-decoration-none">
                        <RoundIcon icon="fa-light fa-pen-to-square" variant={RoundIconVariants.variant2} onClick={onEditClick} />
                    </div>
                )}

                <Typography tagVariant={TypographyTagVariants.span}>
                    <div
                        className={`${
                            styles['service-about-text'] + `  ${useGrayscaleTheme ? styles['theme-grayscale'] : ''}`
                        } text-muted`}
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}></div>
                </Typography>
            </div>
        </Container>
    );
};
